import { useCallback, useMemo } from "react";

import { useTabState } from "@features/sales-v3/hooks/use-tab-state";
import { useExpandedRowIds } from "@features/sales-v3/table/contexts";

import { TAB_RANKING } from "../constants/tab";

export const useResetTabStates = () => {
  const adTabState = useTabState("ad");
  const adsetTabState = useTabState("adset");
  const campaignTabState = useTabState("campaign");
  const breakdownTabState = useTabState("breakdown");
  const [, setExpandedRowIds] = useExpandedRowIds();

  const tabStates = useMemo(
    () => ({
      breakdown: breakdownTabState,
      campaign: campaignTabState,
      adset: adsetTabState,
      ad: adTabState,
    }),
    [breakdownTabState, campaignTabState, adsetTabState, adTabState],
  );

  const resetAllStates = useCallback(() => {
    TAB_RANKING.forEach((tab) => tabStates[tab].unsetTabState());
    setExpandedRowIds([]);
  }, [setExpandedRowIds, tabStates]);

  return { resetAllStates };
};
